import { DeepLinkSourceSchema, type DeepLinkSource } from '../schemas/shop.schema';

/**
 * Deep-link source attribution (AC1). Power to Choose (and other partner
 * catalogues) deep-link straight to a plan with `?src=ptc`. An unrecognised or
 * absent `src` is treated as organic — never an error, never trusted for
 * anything security-sensitive (it is pure attribution/UX).
 */
export function parseSource(raw: string | null | undefined): DeepLinkSource {
  const result = DeepLinkSourceSchema.safeParse(raw);
  return result.success ? result.data : 'organic';
}

/**
 * A deep link is an external landing on a specific plan (AC1): show the plan +
 * address input, skip the needs-quiz (AC3). Organic entry (the shelf) shows the
 * quiz. Today the only external source is `ptc`; the predicate is the seam that
 * keeps that list in one place.
 */
export function isDeepLink(source: DeepLinkSource): boolean {
  return source === 'ptc';
}

/** The i18n key for the source badge label. */
export function sourceLabelKey(source: DeepLinkSource): string {
  return `shop.deepLink.source.${source}`;
}
